<template>
  <section
    v-if="sliderItems.length"
    id="documents"
    class="d-flex flex-column"
    :class="isMobile ? 'ga-4' : 'ga-6'"
    data-qa="lpu_documents"
  >
    <h2
      class="text--text"
      :class="isMobile ? 'text-h6' : 'text-h5'"
      data-qa="lpu_documents_title"
    >
      {{ tStatic('Документы') }}
    </h2>

    <CoreImageSlider
      :items="sliderItems"
      :style="{
        minHeight: '240px',
      }"
    />
  </section>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import useIsMobile from 'src/composables/useIsMobile'
import CoreImageSlider from 'src/core/CoreImageSlider/CoreImageSlider.vue'
import type { CoreImageSliderItem } from 'src/core/CoreImageSlider/types'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'
import type { LpuDocument } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuDocuments/types'

const props = defineProps<{
  documents: LpuDocument[]
  lpuName?: string
}>()

const isMobile = useIsMobile()

function getDocumentSrc(document: LpuDocument) {
  return document.img_l?.url || document.img_s?.url || ''
}

function getDocumentTitle(document: LpuDocument) {
  return document.doc_type?.name || document.title || ''
}

function getDocumentAlt(document: LpuDocument) {
  const title = getDocumentTitle(document)

  if (props.lpuName && title) {
    return `${props.lpuName} - ${title}`
  }

  return title || props.lpuName || ''
}

const sliderItems = computed((): CoreImageSliderItem[] => (
  props.documents
    .filter(document => Boolean(getDocumentSrc(document)))
    .map(document => {
      const title = getDocumentTitle(document)

      return {
        id: document.id,
        src: getDocumentSrc(document),
        previewSrc: document.img_s?.url || document.img_l?.url || undefined,
        title,
        alt: getDocumentAlt(document),
      }
    })
))
</script>
